import React from 'react';
import Provider from './Provider';

const ProviderList = ({ filter, providers, providerSelect }) => (
    <ul className="watchProvider__list-items">
        {providers
            .filter((provider) => (provider.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0))
            .map((provider) => (
                <Provider
                    key={provider.id}
                    provider={provider}
                    providerSelect={() => providerSelect(provider)}
                />
            ))
        }
    </ul>
);

ProviderList.propTypes = {
    filter: React.PropTypes.string,
    providerSelect: React.PropTypes.func,
    providers: React.PropTypes.array
};

ProviderList.defaultProps = {
    providers: []
};

export default ProviderList;



// WEBPACK FOOTER //
// ./app/modal/authn/ProviderList.js